import { PoiFeatureCollection, Poi } from '../types';

function extractVideoUrl(html: string): string | null {
  const match = html.match(/href="([^"]+)"/);
  return match ? match[1] : null;
}

export function geojsonToPoisArray(geojson: PoiFeatureCollection): Poi[] {
  return geojson.features.map((feature) => ({
    lng: feature.geometry.coordinates[0],
    lat: feature.geometry.coordinates[1],
    name: feature.properties.Name,
    videoUrl: extractVideoUrl(feature.properties.description),
    description: feature.properties.description,
  }));
}

export function getPois(geoJson: string): Poi[] {
  return geojsonToPoisArray(JSON.parse(geoJson));
}
